const constants = {
    MY_BAG: 'My Bag',
    BILLING_DETAILS: 'Billing Details',
    RS:'Rs '
}
export default constants;